import { QueryClient } from "react-query";
import axios from "axios";
import { store } from "../store";
import { resetAuthState } from "@funded-here-interface/common/src/features/auth/authSlice_Investor";
import { SessionInvalidatedError } from "@funded-here-interface/common/src/Utils/axiosSessionInterceptor";
import { isSessionInvalidationInProgress } from "@funded-here-interface/common/src/Utils/sessionState";
import { RefreshCooldownError } from "@funded-here-interface/common/src/hooks/useRefreshAuth";

const handleOnError = (message: string) => {
  if (message === "Unauthorized" && window.location.pathname !== "/login") {
    store.dispatch(resetAuthState());
    window.location.replace("/login");

    return;
  }
};

// Global Axios interceptor — ensures raw Axios calls (outside React Query)
// also trigger logout on 401, matching the React Query onError behavior above.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      window.location.pathname !== "/login"
    ) {
      store.dispatch(resetAuthState());
      window.location.replace("/login");
    }
    return Promise.reject(error);
  }
);

const client = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (e) => {
        if (e instanceof SessionInvalidatedError) return;
        if (e instanceof RefreshCooldownError) return;
        handleOnError((e as Error).message);
      },
    },
    queries: {
      onError: (e) => {
        if (e instanceof SessionInvalidatedError) return;
        if (e instanceof RefreshCooldownError) return;
        handleOnError((e as Error).message);
      },
    },
  },
});

export { client };
